<template>
  <div>
    <div class="container" @click="boxClick">
      <div class="operateBox">
        <div class="operateItem" @click.stop="typeClick(1)">
          <div style="background: #df5e5e">
            <div class="iconfont icon-favorites"></div>
            <div class="redDot" v-if="msgData.HasLikeMessage"></div>
          </div>
          <div class="title">点赞</div>
        </div>
        <div class="operateItem" @click.stop="typeClick(2)">
          <div style="background: #71c589">
            <div class="iconfont icon-account"></div>
            <div class="redDot" v-if="msgData.HasFollowMessage"></div>
          </div>
          <div class="title">关注</div>
        </div>
        <div class="operateItem" @click.stop="typeClick(3)">
          <div style="background: #5a65a7">
            <div class="iconfont icon-huati1"></div>
            <div class="redDot" v-if="msgData.HasTopicMessage"></div>
          </div>
          <div class="title">话题</div>
        </div>
        <div class="operateItem" @click.stop="typeClick(4)">
          <div style="background: #d9a55b">
            <div class="iconfont icon-pinglun1"></div>
            <div class="redDot" v-if="msgData.HasCommentMessage"></div>
          </div>
          <div class="title">评论</div>
        </div>
        <div class="operateItem" @click.stop="typeClick(5)">
          <div style="background: #5999cf">
            <div class="iconfont icon-tongzhi"></div>
            <div class="redDot" v-if="msgData.HasSystemMessage"></div>
          </div>
          <div class="title">系统通知</div>
        </div>
      </div>

      <div class="messageBox">
        <div class="title">离线未读</div>
        <!-- <div
          class="hasData"
          v-if="conversationList != null && conversationList.length > 0"
        >
          <conversation-item
            :conversation="item"
            v-for="item in conversationList"
            :key="item.conversationID"
          />
        </div> -->
        <div class="noDataBox">
          <span class="iconfont icon-kong"></span>
          <div>什么也没有！</div>
        </div>
      </div>
    </div>

    <FooterTab ref="childData"></FooterTab>
  </div>
</template>
<script>
import FooterTab from "@/components/FooterTab";
import { checkMessage } from "@/api/index";

// import { mapState } from "vuex";
// import { isToday, getDate, getTime } from "../../utils/date";
// import ConversationItem from "../../components/conversation/conversation-item";
export default {
  name: "message",
  components: {
    FooterTab,
    // ConversationItem,
  },
  data() {
    return {
      type: 1, //1点赞 2新增 3评论 4系统
      msgData: "",
    };
  },
  computed: {
    // ...mapState({
    //   conversationList: (state) => state.conversation.conversationList,
    //   currentConversation: (state) => state.conversation.currentConversation,
    // }),
  },
  watch: {},
  filters: {
    // formatCreateTime(lastTime) {
    //   const date = new Date(lastTime * 1000);
    //   if (isToday(date)) {
    //     return getTime(date);
    //   }
    //   return getDate(date);
    // },
  },
  methods: {
    //点击其他空白，隐藏发布按钮
    boxClick() {
      this.$refs["childData"].publishBtn = false;
    },

    //检查新消息
    getCheckMessage() {
      checkMessage().then((res) => {
        this.msgData = res.Data;
      });
    },

    //类型点击
    typeClick(type) {
      if (type == 1) {
        this.$router.push("/myLike");
      } else if (type == 2) {
        this.$router.push("/myAttention");
      } else if (type == 3) {
        this.$router.push("/myTopic");
      } else if (type == 4) {
        this.$router.push({ path: "/comment", query: { type: 1 } });
      } else if (type == 5) {
        this.$router.push("/sysMessage");
      } else {
      }
    },

    // handleRefresh() {
    //   this.refreshConversation()();
    // },
    
    // refreshConversation() {
    //   let that = this;
    //   return function () {
    //     if (!that.timeout) {
    //       that.timeout = setTimeout(() => {
    //         that.timeout = null;
    //         that.tim.getConversationList().then(() => {
    //           that.$store.commit("showMessage", {
    //             message: "刷新成功",
    //             type: "success",
    //           });
    //         });
    //       }, 1000);
    //     }
    //   };
    // },

    // //跳转聊天
    // contactsClick(cid, avatar, name) {
    //   localStorage.setItem("_imOtherAvatar", avatar);
    //   this.$router.push({ path: "/chat", query: { cid: cid, name: name } });
    // },
  },

  created() {
    // this.handleRefresh();
    this.$store.commit("setFooterNav", "message");
  },
  mounted() {
    this.getCheckMessage();
  },
  // updated() {
  //   this.handleRefresh();
  // },
};
</script>
<style lang="less" scoped>
.container {
  min-height: 100vh;
  .operateBox {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 23px 15px 18px 15px;
    border-bottom: 10px solid #f5f5f5;
    .operateItem {
      color: #333;
      font-size: 13px;
      text-align: center;
      div {
        &:first-child {
          width: 55px;
          height: 55px;
          border-radius: 27px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          -webkit-border-radius: 27px;
          -moz-border-radius: 27px;
          -ms-border-radius: 27px;
          -o-border-radius: 27px;
          .iconfont {
            color: #ffffff;
            font-size: 30px;
          }
          .redDot {
            width: 10px;
            height: 10px;
            background: #d62f2f;
            border: 2px solid #ffffff;
            border-radius: 50%;
            position: absolute;
            z-index: 2;
            top: 0;
            right: 0;
          }
        }
      }
      .title {
        margin-top: 10px;
      }
    }
  }
  .messageBox {
    padding: 23px 15px 60px 15px;
    color: #333;
    .title {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 5px;
    }
    .ml_item {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 15px 0;
      border-bottom: 1px solid #eeeeee;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
      div {
        font-size: 13px;
        color: #333333;
        line-height: 18px;
        width: 293px;
        div {
          &:first-child {
            color: #999999;
            margin-bottom: 6px;
            display: flex;
            flex-flow: wrap;
          }
        }
      }
    }
    .time {
      padding-left: 25px;
      position: relative;
      .time::after {
        display: block;
        content: "";
        position: absolute;
        top: 50%;
        left: 12px;
        transform: translate(0, -50%);
        width: 1px;
        height: 12px;
        background: #cccccc;
      }
    }
  }
}
</style>
